<div class="app-update-dialog-content">
  <div class="update-icon">
    <mat-icon>system_update</mat-icon>
  </div>

  <h2 class="popup-title">New App Version is Available</h2>

  <div class="update-message">
    <p class="update-recommendation">It’s strongly recommended to reload Application to the latest version. Press “No, thank“ to save the data. Application will be reloaded automatically in {{ data.autoReloadDelayMinutes }} minutes.</p>
  </div>

  <div class="update-actions">
    <button
      (click)="updateLater()"
      class="btn-purple">
      No Thanks
    </button>
    <button
      (click)="updateNow()"
      class="btn-primary-accept">
      Reload
    </button>
  </div>
</div>
